import {useAppToast} from "@ui-seeker/app"
import {getPreviousDate, postSubmit} from "@ui-seeker/utils"

import {commonFiltersValue, currentPeriod, dateRangePeriod, favFilterSelected, setCommonFilters} from "@signals"
import {favFiltersData} from "../@signals"
import {WEBBACK_V2_API, DATE_PERIODS} from "@constants"
import {batch} from "@preact/signals-react";
import {track} from "@analytics";


export default function useFavFilterModal() {

    const { showToast } = useAppToast()

    const getFavouriteFilters = (dashboardKey, setFilterSelected=false, allowedFilters = []) => postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/list`, {
        dashboardKey: dashboardKey,
    }).then(res => {
		favFiltersData.value = res
        if (setFilterSelected) {
            favFilterSelected.value = favFiltersData.value.find( filter => filter.defaultFilter === true).value

            const normalizedFilters = {}

            currentPeriod.value = favFilterSelected.value.currentPeriod
            normalizedFilters.currentPeriod = favFilterSelected.value.currentPeriod

            if (currentPeriod.value === DATE_PERIODS.CUSTOM) {
                normalizedFilters.startDate = favFilterSelected.value.startDate
                normalizedFilters.endDate = favFilterSelected.value.endDate
            }

            normalizedFilters.currentSingleDate = dateRangePeriod.value[1]
            normalizedFilters.prevSingleDate = getPreviousDate({ days: 1 }, dateRangePeriod.value[1])

            allowedFilters.forEach(key => {
                if (favFilterSelected.value.hasOwnProperty(key))
                    normalizedFilters[key] = favFilterSelected.value[key]
            })
            setCommonFilters(normalizedFilters)
        } else {
            favFilterSelected.value = null
        }
	})

    const deleteFavGroupFilter = filterID => showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/delete`, { filterID: filterID }).then(res => {
		favFiltersData.value = favFiltersData.value.filter(row => row.filterID != res.filterID)
	}),{
        error: 'Error',
        success: `The group has been successfully deleted.`,
    })

    const insertFavGroupFilter = (name, existingFilterID) => {
        const handleSubmit = () => {
            showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/insert`, {
                name: name,
                overwrite: existingFilterID,
                filter: commonFiltersValue.peek()
            }).then(res => {
                // The filter's name is typed by the user, so only the fact and the shape are sent.
                track('filters_saved', { overwrite: !!existingFilterID })
                favFiltersData.value = updateFavFiltersData(res, existingFilterID)
            }), {
                error: 'Error',
                success: `Group filter successfully created.`,
            })
        }

        if (!!existingFilterID) {
            return showToast.confirm(`Theres another filter with the same name, you want to overwrite it?`, {
                onSubmit: () => handleSubmit()
            })
        }
        return handleSubmit()
    }

    const updateFavFiltersData = (row, existingFilterID) => {
        if (existingFilterID) {
            return favFiltersData.value.map(filter => filter.filterID === existingFilterID ? row : filter)
        }
        return [...favFiltersData.value, row]
    }

    const setFilterDefaultInDashboard = (dashboardKey, filterID, updateSelected=false) => showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/filter-default`, {
            dashboardKey: dashboardKey,
            filterID: filterID
        }).then(res => {
                favFiltersData.value = [...res.allData]
                if (updateSelected) {
                    const actualID = filterID
                    favFilterSelected.value = favFiltersData.value.find(f => f.filterID === actualID).value
                }
        }), {
                success: `Default Dashboard Filter Updated.`,
    })

    return {
        getFavouriteFilters,
        deleteFavGroupFilter,
        insertFavGroupFilter,
        setFilterDefaultInDashboard
    }
}